<img #pane [src]="image" class="position-absolute" onerror="this.style.display='none'" [ngStyle]="{
    'top.px': box.top,
    'max-width.px': box.width,
    'max-height.px': box.height,
    'left.px': box.left,
    'visibility': visibility,
  }" 
 />
